"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataCy = exports.SidePageActions = void 0;
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex",
      alignItems: "center",
      padding: "8px 12px",
      justifyContent: function justifyContent(_ref) {
        var _justifyContent = _ref.justifyContent;
        return _justifyContent;
      },
      flex: "0 0 auto",
      minHeight: "64px",
      borderTop: function borderTop(_ref2) {
        var divider = _ref2.divider;
        return divider ? "1px solid ".concat(theme.palette.divider) : undefined;
      }
    },
    spacing: {
      "& > :not(:first-child)": {
        marginLeft: 16
      }
    }
  };
});
var dataCy = exports.dataCy = "SidePageActions";
var SidePageActions = exports.SidePageActions = function SidePageActions(_ref3) {
  var children = _ref3.children,
    _ref3$divider = _ref3.divider,
    divider = _ref3$divider === void 0 ? true : _ref3$divider,
    _ref3$justifyContent = _ref3.justifyContent,
    justifyContent = _ref3$justifyContent === void 0 ? "flex-end" : _ref3$justifyContent;
  var classes = useStyles({
    divider: divider,
    justifyContent: justifyContent
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _clsx["default"])(classes.root, classes.spacing),
    "data-cy": dataCy,
    children: children
  });
};
SidePageActions.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].array, _propTypes["default"].node]),
  divider: _propTypes["default"].bool,
  justifyContent: _propTypes["default"].oneOf(["flex-start", "center", "flex-end", "space-between"])
};